import Entity from '../entity'

export default class Employee extends Entity<number>{
    dealer_id: number;
    code: string;
    fullname: string;
    phone: string;
    email: string;
    active: boolean;
}


